<template>
  <div class="wrapBox">
    <div class="screenBox">
      <div class="contract-manage">
        <el-radio-group v-model="searchFormData.type" style="margin-right:30px" @change="agreeChange()"> 
          <el-radio-button label="1">日</el-radio-button>
          <el-radio-button label="2">周</el-radio-button>
          <el-radio-button label="3">月</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-show="searchFormData.type !='3'"
          v-model="searchFormData.rangDate"
          value-format="timestamp"
          @change="changeRangDate()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :default-time="['00:00:00', '23:59:59']"
          >
        </el-date-picker>
        <el-date-picker
          v-show="searchFormData.type =='3'"
          v-model="searchFormData.rangDate"
          value-format="timestamp"
          @change="changeRangDate()"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :default-time="['00:00:00', '23:59:59']"
          >
        </el-date-picker>
      </div>

      <div>
        <el-radio-group v-model="searchFormData.brand" style="margin-right:30px"  @change="setBarChart()">  
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="4">华为</el-radio-button>
          <el-radio-button label="1">OPPO</el-radio-button>
          <el-radio-button label="2">vivo</el-radio-button>
          <el-radio-button label="3">小米</el-radio-button>
        
          <el-radio-button label="5">iOS</el-radio-button>
          <el-radio-button label="6">其他</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="searchFormData.dataType"   @change="setDataType()" >  
          <el-radio-button label="1">新增</el-radio-button>
          <el-radio-button label="2">累计</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div id="lineChartBox">

    </div> 
    <div class="listBox">
      <div class="titleBox">
        <h1 class="title">链接访问{{searchFormData.dataType==1?'新增':'累计'}}数据</h1>
        <el-button  class="exportButton" type="primary" @click="exportClick()">导出数据</el-button>
      </div>
      <el-table
        class="tableBox"
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }">
        
        <el-table-column
          width="50" 
          type="index"        
          label="序号">
        </el-table-column>
        <el-table-column
          width="120" 
          prop="stat_time"         
          label="日期">
        </el-table-column>
        <el-table-column      
          label="全部">
           <el-table-column           
              prop="new_visit_count"
              label="访问量">
            </el-table-column>
            <el-table-column        
              prop="new_account_visit_count"
              label="访问用户">
            </el-table-column>
        </el-table-column>
        <el-table-column      
          label="OPPO">
           <el-table-column           
              prop="oppo_new_visit_count"
              label="访问量">
            </el-table-column>
            <el-table-column        
              prop="oppo_new_account_visit_count"
              label="访问用户">
            </el-table-column>
        </el-table-column>
        <el-table-column      
          label="vivo">
           <el-table-column           
              prop="vivo_new_visit_count"
              label="访问量">
            </el-table-column>
            <el-table-column        
              prop="vivo_new_account_visit_count"
              label="访问用户">
            </el-table-column>
        </el-table-column>
        <el-table-column      
          label="小米">
           <el-table-column           
              prop="xiaomi_new_visit_count"
              label="访问量">
            </el-table-column>
            <el-table-column        
              prop="xiaomi_new_account_visit_count"
              label="访问用户">
            </el-table-column>
        </el-table-column>
        <el-table-column      
          label="华为">
           <el-table-column           
              prop="huawei_new_visit_count"
              label="访问量">
            </el-table-column>
            <el-table-column        
              prop="huawei_new_account_visit_count"
              label="访问用户">
            </el-table-column>
        </el-table-column>
        <el-table-column      
          label="iOS">
           <el-table-column           
              prop="ios_new_visit_count"
              label="访问量">
            </el-table-column>
            <el-table-column        
              prop="ios_new_account_visit_count"
              label="访问用户">
            </el-table-column>
        </el-table-column>
        <el-table-column      
          label="其他">
           <el-table-column           
              prop="other_new_visit_count"
              label="访问量">
            </el-table-column>
            <el-table-column        
              prop="other_new_account_visit_count"
              label="访问用户">
            </el-table-column>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchFormData.perPage"
          :current-page="searchFormData.page"
          layout="total, prev, pager, next, sizes"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
export default {
  data(){
    return{
      pickerOptions:{
        disabledDate(time) {
          return time.getTime() >= new Date(new Date().toLocaleDateString()).getTime()
          
        },
      },
      total: 0,
      tableData:[],
      searchFormData:{
        id:'',
        type:"1",
        dataType:"1",//判断是新增还是累计  1新增 2累计
        brand:0,
        rangDate: [new Date().getTime() - 30 * 24 * 60 * 60 * 1000, new Date().getTime() - 24 * 60 * 60 * 1000],
        startTime:"",
        endTime:"",
      },
      myLineChart:"",
      lineOption:{
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '',
            type: 'line',
            data: []
          },
          {
            name: '',
            type: 'line',
            data: []
          },
          {
            name: '',
            type: 'line',
            data: []
          },
          {
            name: '',
            type: 'line',
            data: []
          },
        ],
      }
    }
  },
  created(){
    this.searchFormData.id = this.$route.query.appId;
    this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
    this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
    this.getList();
  },
  mounted(){
    this.setLineChart();
  },
  methods:{
    //改变日周月时触发  
    agreeChange(){
      this.searchFormData.page=1;
      if(this.searchFormData.type==1){
        this.searchFormData.rangDate = [new Date().getTime() - 30 * 24 * 60 * 60 * 1000, new Date().getTime() - 24 * 60 * 60 * 1000]
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
      } else if(this.searchFormData.type==2){
        this.searchFormData.rangDate = [new Date().getTime() - 180 * 24 * 60 * 60 * 1000, new Date().getTime() - 24 * 60 * 60 * 1000]
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
      }else{
        this.searchFormData.rangDate = [new Date().getTime() - 365 * 24 * 60 * 60 * 1000, new Date().getTime()]
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
        this.searchFormData.startTime=new Date(this.searchFormData.startTime).setDate(1);
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
      }
      this.setLineChart();
      this.getList();
    },


    setBarChart(){
      this.setLineChart();
      this.getList();
    },
    
    //选择时间时触发
    changeRangDate(){
      this.searchFormData.page=1;
      this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: '';
      if(this.searchFormData.type == '3'){
          var date = new Date(this.searchFormData.rangDate[1]);
          // 下月1号-1秒 
          this.searchFormData.endTime = new Date(date.getFullYear(), date.getMonth() + 1, 1).getTime()-1000;
      }else{
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: '';
      }
      this.setLineChart();
      this.getList();
    },

    setDataType(){
      this.setLineChart();
      this.getList();
    },

    //获取应用分发列表
    getList() {
      this.$apis.consoleSever.queryAppLinkAccessDataList(this.searchFormData).then(res => {
        if (res['code'] == 0 && res.data) {
          this.tableData=res.data.data;
          this.total = res.data.total
        }else {
          this.total = 0
          this.tableData = []
        }
      });
    },

    //获取折线图数据
    setLineChart() {
      var lineChart=document.getElementById("lineChartBox");
      // lineChart.style.width=window.innerWidth-300+'px';
      this.myLineChart = echarts.init(lineChart);
      this.$apis.consoleSever.queryLinkAccessData(this.searchFormData).then(res=>{
        if (res['code'] == 0 && res.data.chart.series) {
          this.lineOption.legend.data=res.data.chart.legend;
          this.lineOption.xAxis.data=res.data.chart.xAxis;        
          for(let key in res.data.chart.series){
            this.lineOption.series[key]["name"]=res.data.chart.series[key]["name"];
            this.lineOption.series[key]["data"]=res.data.chart.series[key]["data"];
          }
          this.myLineChart.setOption(this.lineOption,true);
          window.addEventListener('resize', () => {
            // lineChart.style.width=window.innerWidth-300+'px';
            this.myLineChart.resize();
          })
        }else{
            for (var i = 0; i < this.lineOption.series.length; i++) {  //置空关键！！！  清空名字和数据
            this.lineOption.series[i].data = [];
            // this.lineOption.series[i].name = '';              
          }
          this.lineOption.xAxis.data=[]; 
          this.myLineChart = echarts.init(lineChart)  //再次初始化
          this.myLineChart.setOption(this.lineOption, true)  //重新setOption
        }
      })       
    },

    exportClick(){
      this.$apis.consoleSever.exportLinkAccessDataList(this.searchFormData).then(res => {
        if (res['code'] == 0 && res['data']['link']) {
          let link = res.data.link;
          window.location.href = link;
        }
      });
    },

    handleSizeChange(val) {
      this.searchFormData.perPage = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.searchFormData.page = val
      this.getList()
    }
    

  }
}
</script>

<style scoped lang="scss">
.wrapBox{
  margin-top: 0;
  #lineChartBox{
    margin-top:30px;
    width: 100%;
    height: 500px;
  }
  .screenBox{
    display: flex;
    justify-content: space-between;
   
  }
  .contentBox{
    margin-top: 20px;
    display: flex;
    .titleBox{
      width: 100%;
      height: 50px;
      background: #F5F5F5;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      border-bottom:  1px solid rgba(0,0,0,0.1);;
    }
    .dataBox{
      width: 30%;
      margin-right: 50px;
      background: #fff;
      border: 1px solid rgba(0,0,0,0.1);
      border-radius: 4px 4px 4px 4px;
      .data{
        margin-top: 20px;
        .title{
          padding: 0 20px;
          font-size: 16px;
          height: 30px;
          line-height: 30px;
          font-weight: bold;
        }
        .hr{
          background: #e9e7e7;
        }
        p{
          padding: 0 20px;
          height: 30px;
          line-height: 30px;
          color: #aaa8a8;
          display: flex;
          justify-content: space-between;
        }
      }
        
    }
  }
  .listBox{
    margin-top: 30px;
    .titleBox{
      display: flex;
      justify-content: space-between;
      .title{
        font-size: 16px;
        font-weight: bold;
      }
    }
    .tableBox{
      margin-top: 10px;
    }
    /deep/ .el-tabs__content{
      overflow: initial;
    }
    /deep/ .el-table__header th {
      border-bottom: 1px solid rgba(0,0,0,.1) !important;
      padding: 0;
      height: 32px!important;
      background: #F5F5F5;
    }
  }
}
</style>
<style lang="scss">
.el-table thead.is-group th {
  background: #ebe9e9;
  border:none;
  color:#000;
}
 .contract-manage {
  .el-range-separator {
    width: 24px;
  }
}
</style>
